import {
  FileArchive,
  FolderTree,
  Megaphone,
  Newspaper,
  Radio,
  Settings2,
  SlidersHorizontal,
  Sparkles,
  Video,
  Wrench,
} from "lucide-react";
import { Link } from "react-router-dom";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const sections = [
  { to: "/admin/whatsnew", icon: Sparkles, title: "What's New", desc: "Login popup announcement + archive." },
  { to: "/admin/broadcast", icon: Radio, title: "Broadcast", desc: "Live banner to all users." },
  { to: "/admin/events", icon: Newspaper, title: "Events", desc: "News / events feed." },
  { to: "/admin/resources", icon: Megaphone, title: "Resources & IAN", desc: "Reference + IRS Advance Notice links." },
  { to: "/admin/toolbox", icon: Wrench, title: "Marketing Toolbox", desc: "Social, emails, letters, handbooks." },
  { to: "/admin/videos", icon: Video, title: "Video Library", desc: "Feature / setup / education videos." },
  { to: "/admin/media", icon: FolderTree, title: "Media Library", desc: "Nested media tree + symlinks." },
  { to: "/admin/files", icon: FileArchive, title: "File Assets", desc: "Internal downloadable files." },
  { to: "/admin/transcheck", icon: SlidersHorizontal, title: "Transcript Check", desc: "Parser regression + rules." },
  { to: "/admin/waidsmap", icon: Settings2, title: "WAIDS Map", desc: "W&I category remap table." },
  { to: "/admin/settings", icon: Settings2, title: "System Settings", desc: "IRS e-Services toggle." },
];

export default function AdminHomePage() {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {sections.map((s) => (
        <Link key={s.to} to={s.to}>
          <Card className="hover:shadow-card-hover h-full transition-shadow">
            <CardHeader>
              <s.icon className="text-primary mb-1 size-6" />
              <CardTitle className="text-base">{s.title}</CardTitle>
              <CardDescription>{s.desc}</CardDescription>
            </CardHeader>
          </Card>
        </Link>
      ))}
    </div>
  );
}
